import React from "react";
import "./MonitoringHero.css";
import image from "../monitoringassets/heroimg.jpg";

export default function MonitorHero() {
  return (
    <div id="monitor-hero" className="outsourcemainclass">
      <h2 className="heading">DevOps Monitoring & Observability Services</h2>
      <p className="subheading">
   Gain complete visibility into your applications and infrastructure with BastionEx’s DevOps Monitoring & Observability services. We help organizations proactively monitor systems, analyze performance, and gain actionable insights to ensure reliability, availability, and optimal user experiences across environments.
      </p>
      <div className="image">
        <img src={image} alt="error" />
      </div>
    </div>
  );
}
